import React, { useState, useEffect } from 'react';
import { 
  FaUserCircle, 
  FaChartBar, 
  FaTicketAlt, 
  FaGift, 
  FaVideo, 
  FaChevronDown, 
  FaChevronUp,
  FaBars
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; // ✅ Changed from useNavigation
import axios from 'axios';

const Sidebar: React.FC = () => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [hoveredMenu, setHoveredMenu] = useState<string | null>(null);
  const [hoveredDropdown, setHoveredDropdown] = useState<string | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navigate = useNavigate(); // ✅ Changed from useNavigation
  const [influencerCount, setInfluencerCount] = useState<number | null>(null);

  // COUNT INFLUENCERS
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const response = await axios.get("http://kkk.biznweb.in:5000/api/influencers");
        setInfluencerCount(response.data.data?.length || 0);
      } catch (err) {
        console.error("Failed to fetch influencer count", err);
        setInfluencerCount(0);
      }
    };
    fetchCount();
  }, []);

  // Detect screen size and auto-close sidebar on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleDropdown = (name: string) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Base styles
  const baseMenuItemStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 20px',
    color: '#444',
    fontWeight: 500,
    cursor: 'pointer',
    borderRadius: '8px',
    transition: 'all 0.25s ease',
    userSelect: 'none',
    position: 'relative',
    overflow: 'hidden',
  };

  const baseDropdownItemStyle: React.CSSProperties = {
    padding: '10px 20px 10px 52px',
    color: '#555',
    fontSize: '14px',
    cursor: 'pointer',
    borderRadius: '6px',
    userSelect: 'none',
    transition: 'all 0.25s ease',
    marginLeft: '8px',
    marginRight: '8px',
  };

  // On mobile, hide sidebar and show hamburger
  if (window.innerWidth <= 768 && !isSidebarOpen) {
    return (
      <button
        onClick={toggleSidebar}
        style={{
          position: 'fixed',
          top: '16px',
          left: '16px',
          zIndex: 1000,
          background: '#063970',
          color: 'white',
          width: '40px',
          height: '40px',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          cursor: 'pointer'
        }}
        aria-label="Open menu"
      >
        <FaBars size={20} />
      </button>
    );
  }

  return (
    <div 
      style={{
        width: window.innerWidth <= 768 ? '280px' : '280px',
        minWidth: '280px',
        flexShrink: 0,
        background: 'linear-gradient(160deg, #f8f9ff 0%, #f0f4ff 100%)',
        minHeight: '100vh',
        padding: '16px 0',
        boxShadow: '4px 0 20px rgba(0, 0, 0, 0.08)',
        borderRight: '1px solid #eef2ff',
        position: window.innerWidth <= 768 ? 'fixed' : 'absolute',
        top: 0,
        left: 0,
        zIndex: 999,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Mobile Close Button */}
      {window.innerWidth <= 768 && (
        <div style={{ textAlign: 'right', padding: '8px 16px 0' }}>
          <button
            onClick={toggleSidebar}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#063970',
              fontWeight: 'bold'
            }}
            aria-label="Close menu"
          >
            &times;
          </button>
        </div>
      )}

      <div style={{ padding: '0 24px 24px', textAlign: 'center', marginBottom: '8px' }}>
        <div 
          style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '8px',
            display: 'inline-block',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
          }}
        >
          <img
            src="/assets/img/TreeshawCrop.jpeg"
            alt="Logo"
            style={{ height: '42px', borderRadius: '8px', cursor: 'pointer' }}
            onClick={() => {
              navigate('/Dashboard');
              if (window.innerWidth <= 768) setIsSidebarOpen(false);
            }}
          />
        </div>
      </div>

      <div style={{ padding: '0 12px', flex: 1 }}>
        {/* Dashboard */}
        <div
          style={{
            ...baseMenuItemStyle,
            backgroundColor: hoveredMenu === 'dashboard' ? '#eef4ff' : 'transparent',
            color: hoveredMenu === 'dashboard' ? '#063970' : '#444',
            transform: hoveredMenu === 'dashboard' ? 'translateX(4px)' : 'translateX(0)',
          }}
          onClick={() => {
            navigate('/Dashboard'); // ✅ Changed from window.location.href
            if (window.innerWidth <= 768) setIsSidebarOpen(false);
          }}
          onMouseEnter={() => setHoveredMenu('dashboard')}
          onMouseLeave={() => setHoveredMenu(null)}
        >
          <div 
            style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: hoveredMenu === 'dashboard' ? '#063970' : 'transparent',
              position: 'absolute',
              left: '0',
              top: '50%',
              transform: 'translateY(-50%)',
              transition: 'background-color 0.25s ease'
            }}
          />
          <FaChartBar size={18} color={hoveredMenu === 'dashboard' ? '#063970' : '#666'} />
          <span>Dashboard</span>
        </div>

        {/* Influencer Network */}
        <div
          style={{
            ...baseMenuItemStyle,
            backgroundColor: hoveredMenu === 'influencer' ? '#eef4ff' : 'transparent',
            color: hoveredMenu === 'influencer' ? '#063970' : '#444',
            transform: hoveredMenu === 'influencer' ? 'translateX(4px)' : 'translateX(0)',
            marginTop: '4px'
          }}
          onClick={() => toggleDropdown('influencer')}
          onMouseEnter={() => setHoveredMenu('influencer')}
          onMouseLeave={() => setHoveredMenu(null)}
        >
          <div 
            style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: hoveredMenu === 'influencer' ? '#063970' : 'transparent',
              position: 'absolute',
              left: '0',
              top: '50%',
              transform: 'translateY(-50%)',
              transition: 'background-color 0.25s ease'
            }}
          />
          <FaUserCircle size={18} color={hoveredMenu === 'influencer' ? '#063970' : '#666'} />
          <span>Influencer Network</span>
          <span style={{ marginLeft: 'auto', transition: 'transform 0.3s ease' }}>
            {openDropdown === 'influencer' ? (
              <FaChevronUp 
                color={hoveredMenu === 'influencer' ? '#063970' : '#888'} 
              />
            ) : (
              <FaChevronDown 
                color={hoveredMenu === 'influencer' ? '#063970' : '#888'} 
              />
            )}
          </span>
        </div>

        {openDropdown === 'influencer' && (
          <div 
            style={{
              marginTop: '8px',
              marginBottom: '8px',
              borderRadius: '8px',
              overflow: 'hidden'
            }}
          >
            <div
              style={{
                ...baseDropdownItemStyle,
                backgroundColor: hoveredDropdown === 'sub1' ? '#eef4ff' : 'transparent',
                color: hoveredDropdown === 'sub1' ? '#063970' : '#555',
                transform: hoveredDropdown === 'sub1' ? 'translateX(8px)' : 'translateX(0)',
              }}
              onMouseEnter={() => setHoveredDropdown('sub1')}
              onMouseLeave={() => setHoveredDropdown(null)}
              onClick={() => {
                navigate('/Influencers'); // ✅ Changed from window.location.href
                if (window.innerWidth <= 768) setIsSidebarOpen(false);
              }}
            >
              Influencer List 
              {influencerCount !== null && (
                <span style={{
                  background: '#e0e7ff',
                  color: '#4f46e5',
                  borderRadius: '12px',
                  padding: '0 8px',
                  fontSize: '12px',
                  fontWeight: 600,
                  marginLeft: '8px'
                }}>
                  {influencerCount}
                </span>
              )}
            </div>
          </div>
        )}

        {/* Other menu items */}
        {[
          { key: 'gift', icon: <FaGift size={18} />, label: 'Generate QR', action: () => alert('Generate QR clicked') },
          { key: 'Redeem R', icon: <FaTicketAlt size={18} />, label: 'Redeem Request', action: () => alert('Ticket clicked') },
          { key: 'Admin', icon: <FaVideo size={18} />, label: 'Admin', action: () => navigate('/AdminScreen') }, // ✅ Admin navigation
        ].map((item) => (
          <div
            key={item.key}
            style={{
              ...baseMenuItemStyle,
              backgroundColor: hoveredMenu === item.key ? '#eef4ff' : 'transparent',
              color: hoveredMenu === item.key ? '#063970' : '#444',
              transform: hoveredMenu === item.key ? 'translateX(4px)' : 'translateX(0)',
              marginTop: '4px',
              marginBottom: item.key === 'video' ? '16px' : '0'
            }}
            onClick={() => {
              item.action(); // ✅ Now calls navigate('/Admin')
              if (window.innerWidth <= 768) setIsSidebarOpen(false);
            }}
            onMouseEnter={() => setHoveredMenu(item.key)}
            onMouseLeave={() => setHoveredMenu(null)}
          >
            <div 
              style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                backgroundColor: hoveredMenu === item.key ? '#063970' : 'transparent',
                position: 'absolute',
                left: '0',
                top: '50%',
                transform: 'translateY(-50%)',
                transition: 'background-color 0.25s ease'
              }}
            />
            {React.cloneElement(item.icon as React.ReactElement, {
              color: hoveredMenu === item.key ? '#063970' : '#666'
            })}
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;